import {Record} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

const Model = Record({
    id: '',
    behaviors: new BehaviorsCollection(),
});

function fromAPI(data) {
    return new Model({
        id: data.id,
        behaviors: new BehaviorsCollection(data.behaviors),
    });
}

function toAPI() {
    return {};
}

export default {
    record: Model,
    fromAPI,
    toAPI,
};
